/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Settings_Popover_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure embedding and display options" |
*
* @param {Spaces_Settings_Popover_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_settings_popover_description = /** @type {((inputs?: Spaces_Settings_Popover_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Settings_Popover_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungs- und Anzeigeoptionen konfigurieren")
	return /** @type {LocalizedString} */ ("Configure embedding and display options")
});